import React, { Component } from 'react';
import styles from './NavHeader.module.css';
import NavTab from './NavTab';
import { ReactComponent as SearchIcon } from '../../assets/images/search-button.svg';
import { ReactComponent as HouseIcon } from '../../assets/images/house.svg';
import { ReactComponent as QueueIcon } from '../../assets/images/queue.svg';
import { ReactComponent as CloseIcon } from '../../assets/images/close.svg';
import { SessionContext } from '../../context/SessionContext';
import MainTabContent from '../Tabs/MainTabContent';
import Contract from '../Contract/Contract';
import { Search } from '../Contract/Search';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import ReportsContainer from '../Report/ReportsContainer';
import { ReportContextProvider } from '../Report/ReportsContext';
import classNames from 'classnames';
import AlertBanner from '../shared/AlertBanner/AlertBanner';
import { DealerHome } from '../../Screens/DealerHome/DealerHome';
import { OrderInfoContainer } from '../../Screens/OrderInfoContainer';
import { DealerProfile } from '../DealerProfile/DealerProfile';
import ResourceContainer from '../Resources/ResourceContainer';
import { ContactUs } from '../../Screens/ContactUs/ContactUs';

let mainNavWrapper = styles.mainNavWrapper;
let mainNav = styles.mainNav;
let navTabs = 'nav-tabs';
let navTabsa = styles.navTabsa;
const homeTab = 'dealerhome';

export class NavWrapper extends Component {
    constructor() {
        super();
        this.clickTest = this.clickTest.bind(this);
        this.state = {
            showBanner: true
        };
    }

    clickTest = (tab) => {
        console.log(tab);
    };

    isActiveTab = (index, activeTab) => {
        return index === activeTab ? 'active' : '';
    };

    render() {
        const session = this.context;
        const { accountName } = this.context;
        const accountNameToLower = accountName.toLowerCase();
        const profile = session.getProfile();

        return (
            <>
                <div className='container-fluid'>
                    <nav className={classNames('row', mainNavWrapper)}>
                        <div
                            className={classNames(mainNav, 'nav')}
                            role='tablist'
                        >
                            <button
                                className={styles.mainNavBtn}
                                onClick={() => session.tabDispatch('SET_ACTIVE_TAB', { activeTab: 0 })}
                                role='tab'
                            >
                                <HouseIcon className={styles.iconHome} />
                            </button>
                            {Array.from(session.tabs).map((tab, index) => (
                                <NavTab
                                    title={tab.title}
                                    onClick={() => session.tabDispatch('SET_ACTIVE_TAB', { activeTab: tab.tabId })}
                                    key={index}
                                    isActive={tab.tabId === session.activeTab}
                                    tabNumber={tab.tabId}
                                />
                            ))}
                            {accountNameToLower !== 'staples' && (
                                <button
                                    className={styles.search}
                                    onClick={() =>
                                        session.tabDispatch('ADD_TAB', {
                                            tabId: session.tabs.length + 1,
                                            title: 'Plan Search',
                                            tabType: 'search'
                                        })
                                    }
                                    role='tab'
                                >
                                    <SearchIcon className={styles.iconSearch} />
                                </button>
                            )}

                            {accountNameToLower !== 'staples' && (
                                <button
                                    className={styles.queue}
                                    onClick={() =>
                                        session.tabDispatch('ADD_TAB', {
                                            tabId: session.tabs.length + 1,
                                            title: 'Reports',
                                            tabType: 'reports',
                                            reportType: 'contracts'
                                        })
                                    }
                                    aria-label='Opens Report Queues'
                                    role='tab'
                                >
                                    <QueueIcon className={styles.iconQueue} />
                                </button>
                            )}
                        </div>
                    </nav>
                </div>

                <MainTabContent session={session} />
            </>
        );
    }
}

NavWrapper.contextType = SessionContext;
